<template>
  <div class="wulian">
       <div class="wulibLICK">
           <img class="ditu" style="border-radius: 10px;" src="@/assets/ditu.png" alt="" @click="BtnURL">
           <div>
              <div style="width: 100%;text-align: center;">
               <div class="title" >IOT 科技战役</div>
               <div class="titleY" style="padding-right:15px;">IOT technology campaign</div>
              </div>
               <div style="position:relative;height:340px;">
                <div>
                  <ul style="position:absolute;left:-50px;top:0">
                    <li>新冠相关咨询服务</li>
                    <li>在线问诊配药</li>
                    <li>网络门诊</li>
                    <li>在线自制剂采购</li>
                  </ul>
                </div>
                <div>
                  <ul style="position:absolute;left:175px;top:0">
                    <li>核酸在线开单</li>
                    <li>5G远程访视</li>
                    <li>线下就医精准预约</li>
                    <li>健康宣教服务</li>
                  </ul>
                </div>
              </div>
            </div>
       </div>
  </div>
</template>

<script>
export default {
    data() {
      return {
        
      }
    },
    methods: {
      BtnURL(){
         window.open("http://brjyun.com/#/")
      }
    }
}
</script>

<style lang="scss" scoped>
     .wulian{
        height:764px;
        background-image: url('../../../assets/baire.png');
        background-repeat:no-repeat;
        background-size:cover;
        display: flex;
        align-items:center;
        justify-content:center;
        .wulibLICK{
            width:1200px;
            display: flex;
            justify-content: space-between;
            .ditu{
               width: 552px;
               height: 524px;
            }
            .title{
              font-size: 32px;
              font-family: Alibaba_Bold;
              color: #FFFFFF;
              text-align:right; 
            }
            .titleY{
               font-size: 14px;
               font-family: Helvetica;
               color: #FFFFFF;
               padding-top:16px;
               text-align:right; 
               padding-bottom:73px;
            }
            li{
              font-size: 20px;
              font-family: Alibaba_Medium;
              color: #FFF;
              padding-bottom:20px;
              width:300px;
            }
            .content{
              width: 517px;
              font-size: 16px;
              font-family: Alibaba_Regular;
              color: #FFFFFF;
              line-height:40px;
              text-indent: 2em;
            }
        }
        .block{
           width: 517px;
           display: flex;
           flex-wrap: wrap;
           margin-top:70px;
        }
        .textBlock{
          font-size: 24px;
          font-family: Alibaba_Bold;
          color: #FFFFFF;
          margin-right:50px;
          margin-bottom:30px;
          padding-bottom:8px;
          border-bottom:2px solid #FFFFFF 0%;
        }
        .textBlock.active{
          border-bottom:2px solid #FFFFFF;
        }
     }
      
</style>